<template>
  <article v-if="slide" class="announcement-slide">
    <router-link class="announcement-slide__inner" :to="{ name: 'poster', params: { id: slide.id } }">
      <ImgComponent v-if="slide && slide.img" :img="slide.img" class="announcement-slide__image" />
      <div class="announcement-slide__blackout"></div>
      <div class="announcement-slide__content">
        <div class="announcement-slide__tags">
          <div class="announcement-slide__tag announcement-slide__tag--date">
            <span v-if="slide && slide.date">{{ slide.date | humanDateTime }}</span>
          </div>
          <div class="announcement-slide__tag announcement-slide__tag--limit">
            <span v-if="slide && slide.limit">{{ slide.limit }} +</span>
          </div>
        </div>
        <div class="announcement-slide__text">
          <span v-if="slide && slide.title" class="announcement-slide__title">{{ slide.title }}</span>
          <span v-if="slide && slide.subtitle" class="announcement-slide__subtitle">
            {{ slide.subtitle }}
          </span>
        </div>
      </div>
    </router-link>
  </article>
</template>

<script>
import ImgComponent from "components/ImgComponent.vue";
export default {
  name: "AnnouncementSlide",
  props: {
    slide: Object,
  },
  components: { ImgComponent },
};
</script>

<style lang="stylus">
.announcement-slide {
  width 100%
  height 100%
  border-radius 5px
  overflow hidden

  &__inner {
    position relative
    display grid
    width 100%
    height 100%
  }

  &__image {
    absolute left top
    width 100%
    height 100%
  }

  &__blackout {
    absolute left top
    width 100%
    height 100%
    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 52.08%, rgba(0, 0, 0, 0.82) 76.56%, #000000 100%);
    mix-blend-mode normal
    opacity 0.8
  }

  &__content {
    display flex
    flex-direction column
    justify-content space-between
    z-index 1
    color var(--white)
    padding 28px 28px 25px
  }

  &__tags {
    display flex
    gap 10px
  }

  &__tag {
    display flex
    align-items center
    padding 5px 15px
    border-radius 33px

    span {
      font-size .875em
      font-weight 500
      line-height 17px
    }

    &--date {
      background var(--main)
    }

    &--limit {
      background var(--white_2)
      color var(--black)
    }
  }

  &__text {
    display grid
    grid-gap 10px
  }

  &__title {
    font-size 1.25rem
    font-weight 500
    line-height 30px
    +below(700px) {
      font-size 1rem
      line-height 26px
    }
  }

  &__subtitle {
    font-size .75rem
    line-height 16px
    color var(--gray_2)
  }
}
</style>
